import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { TenantWording, DEFAULT_TENANT_WORDING } from './tenant-theme.interface';

@Injectable({ providedIn: 'root' })
export class TenantWordingService {
  private wordingSubject = new BehaviorSubject<TenantWording>(DEFAULT_TENANT_WORDING);
  wording$: Observable<TenantWording> = this.wordingSubject.asObservable();

  apply(wording: TenantWording): void {
    // ⚠️ Un valor VACÍO no es una declaración: es un campo que la marca no llenó,
    // y tiene que heredar el default. Con el spread pelado, un `''` GANABA —
    // `{...DEFAULT, ...{appName: ''}}` deja `appName` en blanco— y el pantallazo
    // era feo de dos maneras: el título de la pestaña quedaba vacío (el navegador
    // muestra la URL) y las ~20 pantallas que imprimen `appName` ("Cuenta
    // {{appName}}", buscadores, encabezados de tabla) se quedaban con el hueco.
    // El alta de marcas no exige el nombre, así que llegar en blanco es normal.
    const declarados: Record<string, string> = {};
    for (const [llave, valor] of Object.entries(wording ?? {})) {
      if (typeof valor === 'string' && valor.trim() !== '') declarados[llave] = valor;
    }
    const merged: TenantWording = { ...DEFAULT_TENANT_WORDING, ...declarados };
    merged.appNameLower = merged.appName.toLowerCase();
    this.wordingSubject.next(merged);
  }

  get(key: string): string {
    return this.wordingSubject.value[key] ?? '';
  }

  getSnapshot(): Readonly<TenantWording> {
    return this.wordingSubject.value;
  }

  reset(): void {
    this.wordingSubject.next(DEFAULT_TENANT_WORDING);
  }
}
